import qs from 'qs';

import { config } from '@/config/config';
import { ApiClient, RequestConfig } from '@/utils/api/api-client';

export const cmsApiClient = new ApiClient(config.cmsApi.url);

async function addTokenToRequest(requestConfig: RequestConfig): Promise<RequestConfig> {
  const cmsAuthorization = config.cmsApi.apiKey;
  const { params } = requestConfig;

  const resolvedHeaders = {
    ...requestConfig.headers,
  };

  requestConfig.params = qs.stringify(params, {
    encodeValuesOnly: true,
  });

  if (cmsAuthorization) {
    const existingAuthorization = requestConfig.headers?.Authorization;
    if (!existingAuthorization) {
      resolvedHeaders['Authorization'] = `Bearer ${cmsAuthorization}`;
    }
  }

  return {
    ...requestConfig,
    headers: resolvedHeaders,
  };
}

cmsApiClient.addRequestInterceptor(async (requestConfig) => {
  return addTokenToRequest(requestConfig);
});
